import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

const GET_UNASSIGNED_TRAINING_KEY = 'get-unassigned-training-key'

type GetOperatorUnassignedTrainingProgramsResponse = {
  programId: string
  displayName?: string
  description?: string
  color: string
  iconType?: string | null
}[]

export function useGetUnassignedTraining(operatorId?: string) {
  return useQuery({
    queryKey: [GET_UNASSIGNED_TRAINING_KEY, operatorId],
    queryFn: async () => {
      const { data } = await apiClient.get<GetOperatorUnassignedTrainingProgramsResponse>(
        `/int/v3/operators/${operatorId}/unassigned-training-programs`
      )

      return data
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(operatorId),
    select(data) {
      return data.sort((a, b) => (a.displayName ?? '').localeCompare(b.displayName ?? ''))
    },
  })
}
